(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-hero"]) return;
  try {
    
      var options = {
    accessibility: true,
    prevNextButtons: true,
    pageDots: true,
    setGallerySize: false,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 60,
      y2: 45,
      x3: 15
    }
  };

  var $carousel = $('[data-carousel]').flickity(options);
  var $slideContent = $('.slide-content');
  var flkty = $carousel.data('flickity');
  var selectedSlide = flkty.selectedElement;

  flkty.on('settle', function(index) {
    selectedSlide = flkty.selectedElement;
  });

  flkty.on('change', function(index) {
    $slideContent.eq(index).removeClass('mask');

    setTimeout(function() {
      $slideContent.addClass('mask');
    }, 500);
  });

  flkty.on('dragStart', function(event) {
    var index = 0;
    selectedSlide = flkty.selectedElement;

    if (event.layerX > 0) { // direction right
      index = $(selectedSlide).index() + 1;
    } else { // direction left
      index = $(selectedSlide).index() - 1;
    }

    $slideContent.eq(index).removeClass('mask');
  });

  setTimeout(function() {
    $slideContent.addClass('mask');
  }, 500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_messages"] && !Shopify.designMode) return;
  try {
    
  var messageWrappers = document.getElementsByClassName('header-message-block');
  if (window.innerWidth > 768 && messageWrappers.length > 1) {
    var idx = 0;
    setInterval(function () {
      if (idx === messageWrappers.length) {
        idx = 0;
      }
      for (var i = 0; i < messageWrappers.length; i++) {
        if (i == idx) {
          messageWrappers[i].style.display = 'block';
        } else {
          messageWrappers[i].style.display = 'none';
        }
      }

      idx++;
    }, 5000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';

    function lockFocusable(slide) {
      if (slide.tagName === 'A' && slide.hasAttribute('href') && !slide.hasAttribute('data-a11y-href')) {
        slide.setAttribute('data-a11y-href', slide.getAttribute('href'));
        slide.removeAttribute('href');
      }

      var focusables = slide.querySelectorAll(focusableSelector);

      if (slide.matches(focusableSelector)) {
        focusables = Array.prototype.slice.call(focusables);
        focusables.unshift(slide);
      }

      focusables.forEach(function (el) {
        if (!el.hasAttribute('data-a11y-tabindex')) {
          var existingTabIndex = el.getAttribute('tabindex');
          el.setAttribute('data-a11y-tabindex', existingTabIndex === null ? '__none__' : existingTabIndex);
        }

        el.setAttribute('tabindex', '-1');
      });

      slide.setAttribute('inert', '');
    }

    function unlockFocusable(slide) {
      if (slide.tagName === 'A' && slide.hasAttribute('data-a11y-href')) {
        slide.setAttribute('href', slide.getAttribute('data-a11y-href'));
        slide.removeAttribute('data-a11y-href');
      }

      slide.removeAttribute('inert');

      slide.querySelectorAll('[data-a11y-tabindex]').forEach(function (el) {
        var previousTabIndex = el.getAttribute('data-a11y-tabindex');

        if (previousTabIndex === '__none__') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', previousTabIndex);
        }

        el.removeAttribute('data-a11y-tabindex');
      });

      if (slide.hasAttribute('data-a11y-tabindex')) {
        var slidePreviousTabIndex = slide.getAttribute('data-a11y-tabindex');

        if (slidePreviousTabIndex === '__none__') {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', slidePreviousTabIndex);
        }

        slide.removeAttribute('data-a11y-tabindex');
      }
    }

    function syncSlideFocusability(slideshow) {
      var slides = slideshow.querySelectorAll('.slideshow__slide');
      var hasSelectedSlide = slideshow.querySelector('.slideshow__slide.is-selected') !== null;

      slides.forEach(function (slide) {
        var isAriaHidden = slide.getAttribute('aria-hidden') === 'true';
        var isSelected = slide.classList.contains('is-selected');

        if (isSelected && isAriaHidden) {
          slide.setAttribute('aria-hidden', 'false');
          isAriaHidden = false;
        }

        var isHiddenSlide = isAriaHidden || (hasSelectedSlide && !isSelected);

        if (isHiddenSlide) {
          lockFocusable(slide);
        } else {
          unlockFocusable(slide);
        }
      });
    }

    document.querySelectorAll('.slideshow').forEach(function (slideshow) {
      syncSlideFocusability(slideshow);

      var observer = new MutationObserver(function () {
        syncSlideFocusability(slideshow);
      });

      observer.observe(slideshow, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
